import {
    GET_OFFSET_LOADING,GET_SELECTED_DEVICE_RAW_DATA, ERROR_SELECTED_DEVICE_RAW_DATA, CLEAR_SELECTED_DEVICE_RAW_DATA
} from "./constants";

const initialState = {
    id: null,
    name: null,
    loading: true,
    error: '',
    rawData: [],
    count: 0,
    limit: 0,
    offset: 0,
    isRawDataLoading: true,
}

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
         case GET_OFFSET_LOADING:
            return {
                ...state,
                isRawDataLoading: true,
            }
        case GET_SELECTED_DEVICE_RAW_DATA:
            return {
                ...state,
                id: payload.id,
                name: payload.name,
                rawData: payload.rawData,
                count: payload.count,
                limit: payload.limit,
                offset: payload.offset,
                loading: false,
                isRawDataLoading: false,
                error: ''
            }
        case ERROR_SELECTED_DEVICE_RAW_DATA:
            return {
                ...state,
                error: payload,
                loading: false,
                count: 0,
                name: null,
                isRawDataLoading: false,
            }
        case CLEAR_SELECTED_DEVICE_RAW_DATA:
            return initialState
        default:
            return state;
    }
}